import { useLocation } from "react-router-dom";
import { useGetCatalogVendeurQuery } from "../utils/api/catalog/catalog.api";
import { useGetVendeurByApiKeyQuery } from "../utils/api/product/product.api";
import { VendeurApikey } from "../utils/http";
import {
  CatalogVendeurPublic,
  getCatalogShopSlug,
  getCatalogVendeur,
  isCatalogOrderContext,
} from "./catalogTenant";
import { ShopTvaSettings, toShopTvaSettings } from "../utils/tvaDisplayPrice";

/**
 * Devise boutique catalogue (RTK Query) ou legacy API key.
 * Préférer ce hook à getVendeur() dans les composants React.
 */
export function useShopVendeur(): CatalogVendeurPublic | undefined {
  const location = useLocation();
  const inCatalogContext = isCatalogOrderContext(location.pathname);
  const catalogSlug = getCatalogShopSlug();

  const { data: catalogVendeur } = useGetCatalogVendeurQuery(catalogSlug ?? "", {
    skip: !inCatalogContext || !catalogSlug,
  });
  const { data: vendeurByApiKey } = useGetVendeurByApiKeyQuery(VendeurApikey, {
    skip: inCatalogContext || !VendeurApikey,
  });

  const vendeur = inCatalogContext ? catalogVendeur : vendeurByApiKey;
  return (vendeur ?? getCatalogVendeur() ?? undefined) as
    | CatalogVendeurPublic
    | undefined;
}

export function useShopDevise(): string | undefined {
  return useShopVendeur()?.devise;
}

export function useShopTvaSettings(): ShopTvaSettings | undefined {
  return toShopTvaSettings(useShopVendeur());
}
